import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  title: 'Fitness Senior Foundations™',
  description: 'Il framework professionale per una formazione sicura ed efficace: principi di allenamento, valutazione iniziale, adattamenti, fattori di rischio, controindicazioni, segnali di allarme e protocolli di sicurezza per condurre ogni lezione con competenza.'
}, {
  title: 'Movement Library™',
  description: 'Oltre 250 esercizi per adulti maggiori per ogni livello: mobilità, equilibrio, coordinazione, forza, resistenza, flessibilità, postura, prevenzione cadute, lavoro seduto, in piedi, con sedia, bande, palle, in coppia, in gruppo e con componente cognitiva.'
}, {
  title: 'Session Builder System™',
  description: 'Crea lezioni strutturate in pochi minuti con modelli pronti di riscaldamento, attivazione, parte principale e defaticamento. Include pianificatori settimanali, mensili e trimestrali per lezioni da 30, 45 e 60 minuti.'
}, {
  title: 'Ready-To-Use Sessions™',
  description: 'Lezioni complete pronte da insegnare subito, con obiettivo, durata, materiale, esercizi, serie, ripetizioni e indicazioni per ogni categoria: mobilità, equilibrio, forza, coordinazione, prevenzione cadute e lavoro cognitivo.'
}, {
  title: 'Progression Programs™',
  description: 'Piani a lungo termine di 4, 8 e 12 settimane che mantengono i partecipanti in continuo miglioramento: principianti, intermedi, adulti molto attivi, mobilità ridotta, prevenzione cadute e mantenimento funzionale.'
}, {
  title: 'Coaching Tools & Checklists™',
  description: 'Aumenta motivazione e partecipazione con strumenti pronti da stampare: schede allieve, registri presenze, valutazioni, controllo obiettivi, pianificatori e checklist pre e post lezione.'
}];
export function ModulesSection() {
  return <section className="py-10 px-4 sm:px-6 bg-cream border-y-4 border-ivory" data-id="element-114">
      <div className="text-center mb-8" data-id="element-115">
        <h2 className="text-2xl sm:text-4xl font-heading font-bold text-petrol mb-2 leading-tight uppercase" data-id="element-116">
          La Soluzione che Stavi Cercando
        </h2>
        <p className="text-base sm:text-xl font-subheading font-bold text-sage mb-3" data-id="element-117">
          6 moduli professionali in 1 sistema di allenamento completo
        </p>
        <div className="inline-block bg-petrol text-white px-4 py-1.5 rounded mb-4 shadow-sm" data-id="element-118">
          <p className="font-body font-bold text-sm tracking-widest uppercase" data-id="element-119">
            🏋️ FITNESS SENIOR PRO™ — COFANETTO 6 IN 1
          </p>
        </div>
        <p className="max-w-3xl mx-auto text-graphite text-sm sm:text-lg leading-snug" data-id="element-120">
          <span className="font-bold" data-id="element-121">
            FITNESS SENIOR PRO™ è molto più di una raccolta di esercizi.
          </span>{' '}
          È un sistema operativo professionale completo progettato per offrire
          programmi di fitness senior più sicuri, più strutturati e più
          efficaci.
        </p>
      </div>

      <div className="flex flex-col gap-3 max-w-3xl mx-auto" data-id="element-122">
        {modules.map((module, i) => <div key={i} className="bg-ivory border border-gold/30 rounded-lg p-4 sm:p-5 flex gap-3 items-start shadow-sm hover:shadow-md transition-shadow" data-id="element-123">
            <div className="mt-0.5 shrink-0" data-id="element-124">
              <CheckCircle2 className="w-6 h-6 text-sage" data-id="element-125" />
            </div>
            <div data-id="element-126">
              <h3 className="text-base sm:text-lg font-bold text-petrol leading-tight mb-1" data-id="element-127">
                {module.title}
              </h3>
              <p className="text-graphite text-sm sm:text-base leading-relaxed" data-id="element-128">
                {module.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}